/**
 * This file returns a map of all 3rd party hooks stored in the hooks directory.
 * To import the hooks, you can use `import { outlook } from '../path/to/hooks'`
 */

import outlook from './outlook'
import ppme from './ppme'
import pools from './pools'
import xb from './xb'
import donate from './donate'

let hooks = {
  outlook,
  donate,
  ppme,
  pools,
  xb,
}

export function getExternalComponents(env, page) {
  let hook = hooks[env] || {}
  let customComponents = hook.customComponents || []
  return function(position) {
    let filteredComponents = customComponents
      .filter(x => x.page === page && x.position === position)
      .map(x => x.component)

    // TODO: return all components? will have to add `key` prop somehow
    return filteredComponents[0]
  }
}

export { hooks }
export default hooks
